





























































import {SelectMarket} from '@/interfaces/global-data';
import {UserRole} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import Toast from '@/mixins/toast';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import Modal from "@/components/UI/Modal.vue";
import '@/logger';

@Component({
  components: {
    Modal,
    VNodes: {
      functional: true,
      render: (h:any, ctx: any) => ctx.props.vnodes,
    },
  }
})
export default class MarketSelect extends Mixins(Toast, Http, LocalData) {
    @Prop() readonly select_value!: SelectMarket | null;
    @Prop() readonly showAddOption?: boolean;
    @Prop() readonly needShowControls?: boolean;
    
    showModal = false;
    currentEditableMarket: any = {};
    selectValue: SelectMarket = this.select_value ? this.select_value : {
        id: -1,
        tradingName: this.$t('regular.common.selectTradingCompany') as string,
        isDefault: false,
    };
    newCompany: string | null = null;
    dropdownState: boolean = true;
    items: SelectMarket[] = [];
    isChecked: boolean = false;
    changeCompanyNameMap: Map<number, string> = new Map();
    emitName: string = '';
    
    // Computed properties for safe prop access (alternative to local variables)
    get shouldShowAddOption(): boolean {
        return this.showAddOption || false;
    }
    
    get shouldShowControls(): boolean {
        return this.needShowControls || false;
    }

    mounted() {
      this.dropdownState = true;
      this.isChecked = this.selectValue.id !== -1;
      this.loadMarkets();
    }

    hasPermission(): boolean {
      return this.$userRole === UserRole.ROLE_ADMIN;
    }

    created() {
      this.emitName = Object.keys((this as any)._events)[0];
    }

    clearCompany() {
      this.newCompany = '';
    }

    loadMarkets() {
      this.httpLoadTradingNetworks()
        .then((json) => {
          this.items = json.data
            .map((item) => {
              item.editable = true;
              return item;
            })
            .sort((a, b) => {
              return a.id === b.id ? 0 : +(a.id > b.id) || -1;
            });
          this.dropdownState = false;
          if (this.selectValue.id === -1) {
            const preferredItem = this.items.find((item) => item.isDefault)
            if (preferredItem) {
              this.inputChangeListener(preferredItem.tradingName)
            }
          }
          this.$forceUpdate();
        })
        .catch((err) => {});
    }

    changeItem(item: SelectMarket) {
      this.changeCompanyNameMap.set(item.id, item.tradingName);
      this.$log.debug(this.changeCompanyNameMap);
      this.$http.post('/api/trading/networks/update/name', null, { params: { oldTradingId: item.id, newTradingName: item.tradingName } })
          .then((json) => {
            if (item.id === this.selectValue.id) {
              this.selectValue.tradingName = item.tradingName
            }
            this.$emit('updateSelectMarket', this.selectValue);
            this.$log.debug(json.data);
            this.showInfo(this.$t('regular.common.successfullyUpdated') as string);
          })
          .catch((err) => {
            this.$log.debug(err);
            this.showResponseError(err);
          });
    }

    removeItem(item: SelectMarket) {
      this.showAction(
        this.$t('regular.common.confirmDeleteCompany', { name: item.tradingName }) as string,
        {
          position: 'top-center',
          type: 'info',
          singleton: true,
          duration: 10000,
          icon: 'trash',
          theme: 'bubble',
          action: [{
            text: this.$t('regular.common.yes') as string,
            onClick: () => {
              this.removeCompany(item.tradingName);
            },
          }],
        });
    }

    inputChangeListener(selectValue: string) {
      const market = this.items.find(item => item.tradingName === selectValue);
      if (!market) return;
      this.selectValue = market;
      if (this.selectValue.id > 0) {
        this.isChecked = true;
      }
      this.$emit(this.emitName, this.selectValue);
    }

    removeCompany(name: string) {
      this.$http.delete('/api/trading/networks/delete/name', {params: {tradingName: name}})
        .then((json) => {
          this.$log.debug(json.data, this.selectValue);
          if (this.selectValue && name === this.selectValue.tradingName) {
            this.selectValue = {id: -1, tradingName: this.$t('regular.common.selectTradingCompany') as string, isDefault: false};
            this.isChecked = false;
            this.$emit(this.emitName, this.selectValue)
          }
          this.items = this.items
            .filter((item) => item.tradingName !== name)
            .sort((a, b) => {
              return a.id === b.id ? 0 : +(a.id > b.id) || -1;
            });
          this.showInfo(this.$t('regular.common.successfullyDeleted') as string);
        })
        .catch((err) => {
          this.$log.debug(err);
          this.showResponseError(err);
        });

    }

    reset() {
      this.selectValue = {id: -1, tradingName: this.$t('regular.common.selectTradingCompany') as string, isDefault: false};
      this.isChecked = false;
    }

    addCompany() {
      this.$http.post('/api/trading/networks/add?tradingName=' + this.newCompany)
        .then((json) => {
          this.$log.debug(json.data);
          const obj = json.data;
          obj.editable = true;
          this.items.push(obj);
          this.items = this.items.sort((a, b) => {
            return a.id === b.id ? 0 : +(a.id > b.id) || -1;
          });
          this.$forceUpdate();
          this.showInfo(this.$t('regular.common.successfullyAdded') as string);
          this.clearCompany();
        })
        .catch((err) => {
          this.$log.debug(err);
          this.showResponseError(err);
        });

    }

    @Watch('select_value')
    onChanged(newValue: SelectMarket | null) {
      if (newValue == null) {
        this.selectValue = {
          id: -1,
          tradingName: this.$t('regular.common.selectTradingCompany') as string,
          isDefault: false,
        };
      } else {
        this.selectValue = newValue;
      }
    }
  }
